import { IconButton, InputText } from '@dixa/lib-shared-habla';

import styles from '../../searchControls.module.scss';

type FilterSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
};

export const FilterSearchInput = ({
  value,
  onChange,
  placeholder,
}: FilterSearchInputProps): JSX.Element => (
  <div className={styles.searchInputWrapper}>
    <InputText
      className={styles.searchInputText}
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      suffix={
        value
          ? {
              type: 'custom',
              noWrap: true,
              value: (
                <IconButton
                  variant="tertiary"
                  icon="close"
                  onClick={() => onChange('')}
                />
              ),
            }
          : undefined
      }
    />
  </div>
);
